export default __webpack_public_path__ + "static/media/Ablead.e9491b2d.jpg";